import {setUserInfo} from '@/utils/userInfo'
import {setToken} from "@/utils/token";
export default {
  SET_TOKEN: (state, token) => {
    setToken(token)
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    setUserInfo(userInfo)
    state.userInfo = userInfo
    // state.roles = userInfo ? (userInfo.roles ? role_to_arr(userInfo.roles) : ['visitor']) : []
  },
  SET_LIBRARY_MODAL_INFO:(state, modalInfo) => {
    // state.libraryModalInfo = modalInfo
    if(!modalInfo){
      state.libraryModalInfo = {}
    }else {
      state.libraryModalInfo = {
        ...state.libraryModalInfo,...modalInfo
      }
    }
  },
  SET_LIBRARY_MODAL_Visible:(state, visible) => {
    state.libraryModalVisible = visible
    if(visible === false){
      state.libraryModalInfo = {}
    }
  },
  SET_NEWGROUP_MODAL_Visible:(state, visible) => {
      state.newGroupModalVisible = visible
  },
  SET_USERDOWN_STRFILE:(state, userdownStrfile) => {
    state.userdownStrfile = userdownStrfile
  },
  // userdownStrfile
}
// this.$store.commit('updateUserId', nativedata)



// WEBPACK FOOTER //
// ./src/store/mutations.js